<footer class="footer">
  <div class="container-fluid">
    <div class="row text-muted">
      <div class="col-6 text-start">
        <p class="mb-0">
          <a href="#" class="text-muted">
            <strong>Cooxupé - Sismet Admin - Versão 1.1.0-beta.1</strong>
          </a>
        </p>
      </div>
      <div class="col-6 text-end">
        <ul class="list-inline">
          <li class="list-inline-item">
            <a href="#" class="text-muted">Suporte</a>
          </li>
          <li class="list-inline-item">
            <a href="#" class="text-muted">Sobre</a>
          </li>
          <li class="list-inline-item">
            <a href="#" class="text-muted">Termos de uso</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</footer>
